module.exports = __webpack_public_path__ + "assets/img/body_bg - 副本.563cc797.jpg";